import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { inject, Injector, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { NgxMaskConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { ApiModule, Configuration, ConfigurationParameters } from '../assets/js/com/ts_api_client';
import { Environment, URLs } from '../environments/environment';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { AppComponent } from './app.component';
import { BDOModule } from './bdo/bdo.module';
import { UnitPrettyPipe } from './bdo/pipes/unit-pretty.pipe';
import { ZaehlwerktypPipe } from './bdo/pipes/zaehlwerktyp.pipe';
import { checkMaintenance } from './initializer/check-maintenance.initializer';
import { LoginModule } from './login/login.module';
import { SharedModule } from './shared/shared.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateModule } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NgxTranslateModule } from './translate/translate.module';
import { translationsReady } from './initializer/translate-ready.initializer';
import { DateDeserializerInterceptor } from './shared/interceptors/date-deserializer.interceptor';
import { routeTrackingProvider } from './bdo/services/route-tracking.service';
import { ConfirmationService } from './bdo/services/confirmation.service';
import { tosPendingInterceptor } from './shared/interceptors/tos-pending.interceptor';

registerLocaleData(localeDe);

// configuring backend basePath for generated Code
function apiConfigFactory (): Configuration {
  const params: ConfigurationParameters = {
    // set configuration parameters here.
    'basePath': URLs.backend
  };
  return new Configuration(params);
}

const maskConfig: Partial<NgxMaskConfig> = {
  validation: false,
};

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        ReactiveFormsModule,
        AppRoutingModule,
        SharedModule,
        BDOModule,
        FormsModule,
        NativeDateModule,
        MatDatepickerModule,
        LoginModule,
        ApiModule.forRoot(apiConfigFactory),
        AngularSvgIconModule.forRoot(),
        NgxTippyModule,
        NgxMaskDirective,
        NgxMaskPipe,
        NgxTranslateModule], providers: [
        ZaehlwerktypPipe,
        UnitPrettyPipe,
        {
            provide: LOCALE_ID, useValue: 'de-DE'
        },
        routeTrackingProvider,
        ConfirmationService,
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: ['LL', 'DD.MM.YYYY', 'D.M.YYYY'],
                },
                display: {
                    dateInput: 'L',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'EEEEE',
                    monthYearA11yLabel: 'MMMM YYYY',
                },
            },
        },
        { provide: APP_BASE_HREF, useValue: Environment.baseHref },
        provideAppInitializer(() => checkMaintenance(inject(Injector))()),
        provideAppInitializer(() => translationsReady(inject(Injector))()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DateDeserializerInterceptor,
            multi: true
        },

        provideEnvironmentNgxMask(maskConfig),
        provideHttpClient(withXhr(), withInterceptors([tosPendingInterceptor]), withInterceptorsFromDi())
    ] })

export class AppModule {

}
